import React, { useState, useEffect } from "react";
import _ from "lodash";
import axios from "axios";

// AWS
import { API, Storage, Auth } from "aws-amplify";

import { calculatorInstallmentStatus } from "../utils/calculator";

function useLoanSandboxId({ loan_id, paid_date }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (options = { isLoading: true, params: {} }) => {
    try {
      setLoading(options.isLoading);

      // const { data } = await axios.get(
      //   `http://localhost:1338/loan/sandbox/${loan_id}`,
      //   {
      //     params: {
      //       paid_date,
      //       ...options.params,
      //     },
      //     // headers: {
      //     //   Authorization: `Bearer ${(await Auth.currentSession())
      //     //     .getIdToken()
      //     //     .getJwtToken()}`,
      //     // },
      //   }
      // );

      // console.log("data", data);

      const data = await API.get("MoneyHubAdmin", `/loan/sandbox/${loan_id}`, {
        queryStringParameters: {
          paid_date,
          ...options.params,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(data.body);

      setData(
        _.cloneDeep({
          ...parseData.Item,
          // installments: parseData.Item.installments.map((installment) => {
          //   return { ...installment };
          // }),
        })
      );
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setError(true);
    }
  };

  return {
    data,
    setData,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useLoanSandboxId;
